import { TextButton as Button } from '@oneaudi/unified-web-components';
import styled from 'styled-components';
import { COLORS } from '../../styles/variables';
import { device } from '../../styles/devices';

export const OfferWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const MainOfferData = styled.div`
  color: ${COLORS.grey80};
  display: flex;
  flex-direction: row;
  gap: 24px;
`;

export const PercentData = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  width: 125px;
`;
export const PaymentData = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  width: 125px;
`;

export const CpoOffer = styled.div`
  color: ${COLORS.grey80};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
`;
export const Apr = styled.div`
  font-size: 12px;
  line-height: 20px;
`;
export const Percent = styled.div`
  /* font-weight: 700; */
  position: relative;
`;

export const TermCa = styled.div`
  text-align: center;
  /* display: flex;
  flex-direction: column;
  align-items: center; */
`;

export const DividerWrapper = styled.div``;
